import { Type } from '@angular/core'

/**
 * Type-safe Object.assign, which ensures all required props are provided
 */
export function createAndAssign<T extends {}>(constructor: Type<T>, props: T): T {
  return Object.assign(new constructor(), props)
}
